import React, { createContext, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { PDFDocument } from 'pdf-lib';
import api from '../services/api';
export const RequestsContext = createContext({});

function RequestsProvider({ children }) {

    const [modalRequestInfo, setModalRequestInfo] = useState(false)
    const [modalPrintItems, setModalPrintItems] = useState(false)
    const [selectItems, setSelectItems] = useState([])
    const [inputSearchFocus, setInputSearchFocus] = useState(false)
    const [requests, setRequests] = useState([])
    const [haveRequests, setHaveRequests] = useState(true)
    const [dashboard, setDashboard] = useState([])
    const [requestInfo, setRequestInfo] = useState([])
    const [userSelectDate, setUserSelectDate] = useState()
    const [userData, setUserData] = useState()
    const [typeFilter, setTypeFilter] = useState()
    const [uniqDayFilter, setUniqDayFilter] = useState()
    const [startDateFilter, setStartDateFilter] = useState()
    const [endDateFilter, setEndDateFilter] = useState()


    const getAll = async (status) => {
        setHaveRequests(true)
        setRequests([])
        if (!status) {
            const response = await api.get(`panel/get/all/requests?status=${1}`)
            if (response.status == 200) {
                setRequests(response.data)
                return
            }


            if (response.status == 404) {
                setHaveRequests(false)
                setRequests([])
            }
        }
        const response = await api.get(`panel/get/all/requests?status=${status}`)
        console.log(response.status)
        if (response.status == 200) {
            setRequests(response.data)
            return
        }

        if (response.status == 404) {
            setHaveRequests(false)
            setRequests([])
        }
    }
    const getAllRequests = async () => {
        const response = await api.get("requests/get/all")
        if (response.status == 200) {
            setRequests(response.data)
            return
        }

        if (response.status == 404) {
            setHaveRequests(false)
            setRequests([])
        }

    }
    const get = async (name) => {
        if (name == "") {
            getAll()
            return
        }
        const response = await api.get(`/requests/get/by/name/${name}`)
        console.log(response.data)
        if (response.status == 200) {
            setRequests(response.data)
            return
        }

        setRequests([])
    }
    const getBySku = async (name) => {
        if (name == "") {
            getAll()
            return
        }
        const response = await api.get(`/requests/get/${name}`)
        console.log(response.data)
        if (response.status == 200) {
            setRequests(response.data)
            return
        }

        setRequests([])
    }
    const getById = async (id) => {
        const response = await api.get(`panel/get/info/request/${id}`)
        if (response.status == 200) {
            setRequestInfo(response.data[0])
            setModalRequestInfo(true)
            getUser(response.data[0].user_id)
            return
        }

    }
    const getUser = async (id) => {
        const response = await api.get(`panel/get/client/by/id/${id}`)
        console.log(response.data)
        if (response.status == 200) {
            setUserData(response.data[0])
        }
    }
    const getByDate = async (id) => {
        setUserSelectDate(id)
        const response = await api.post("/requests/get/by/date/", {
            "date": id
        })
        console.log(response.data)
        if (response.status == 200) {
            setHaveRequests(true)
            getDashboard(id)
            setRequests(response.data)
            return
        }

        if (response.status == 404) {
            setDashboard({
                send: 0,
                productLoss: 0,
                cartLoss: 0,
            })
            setHaveRequests(false)
        }


    }
    const getDashboard = async (id, status) => {
        try {
            const date = id || new Date(); // Use 'id' se fornecido, caso contrário, a data atual
            const response = await api.post("/dashboard/financial/get",
                {
                    date: date,
                    status: !status ? 1 : status,
                }
            );

            if (response.status === 200) {
                const { totalProducts, productSend, productLoss, cartLoss } = response.data;

                setDashboard({
                    totalProducts,
                    send: productSend,
                    productLoss,
                    cartLoss,
                });
            } else {
                console.error("Erro na resposta da API", response.status);
            }
        } catch (error) {
            console.error("Erro ao buscar dados do dashboard:", error);
        }
    };
    const getLast30Days = async (status) => {

        const response = await api.get(`requests/get/by/last/30/days?status=${status}`)
        if (response.status == 200) {
            setHaveRequests(true)
            setRequests(response.data)
        }

        if (response.status == 404) {
            setHaveRequests(false)
        }


    }
    const formatDate = (dateString) => {
        const date = new Date(dateString)
        return date.toLocaleDateString('pt-BR') // Isso retorna no formato DD/MM/YYYY
    }
    const getByUniqDate = async (status) => {

        const date = new Date()

        const formattedDate = !uniqDayFilter ? date.toDateString("pt-BR") : formatDate(localStorage.getItem("@DATE_UNIQ_DATE_FILTER"))
        const response = await api.get(`requests/get/by/unique/date/?date=${formattedDate}&status=${status}`)

        if (response.status == 200) {
            setHaveRequests(true)
            setRequests(response.data)
        }

        if (response.status == 404) {
            setHaveRequests(false)
        }

    }
    const getRangeDate = async (status) => {

        const date = new Date()

        const startDateFormatted = !startDateFilter ? date.toLocaleDateString("pt-BR") : formatDate(localStorage.getItem("@DATE_UNIQ_START"))
        const endDateFormatted = !endDateFilter ? date.toLocaleDateString("pt-BR") : formatDate(localStorage.getItem("@DATE_UNIQ_END"))

        const response = await api.get(`requests/get/by/range/date?startDate=${startDateFormatted}&endDate=${endDateFormatted}&status=${status}`)
        if (response.status == 200) {
            setHaveRequests(true)
            setRequests(response.data)
        }
        if (response.status == 404) {
            setHaveRequests(false)
        }

    }
    const setFocus = () => {
        setInputSearchFocus(true)
    }
    const removeFocus = () => {
        setInputSearchFocus(false)
        getAll()
    }
    const handleSelectItems = (id, e, type_delivery, price, quantity, coust_delivery) => {
        const checked = e.target.checked;

        setSelectItems((prev) => {
            if (!checked) {
                return prev.filter((item) => item.id !== id);
            } else {
                // Evita duplicar
                if (prev.some((item) => item.id === id)) return prev;
                return [...prev, { id, type_delivery, price, quantity, coust_delivery }];
            }
        });
    };

    const handleGenerateReportAllFlex = async () => {
        const loadingToastId = toast.loading("Processando o pedido...");

        const filterArray = selectItems.filter(item => item.type_delivery == "1")

        if (filterArray.length == 0) {

            return toast.update(loadingToastId, {
                render: "Nenhuma etiqueta flex foi encontrada!",
                type: "error",
                isLoading: false,
                autoClose: 1000
            });
        }

        try {
            // Cria um novo PDF onde todos os PDFs serão combinados
            const combinedPdf = await PDFDocument.create();

            await Promise.all(selectItems
                ?.filter(item => item.type_delivery === "1")  // Filtra antes de mapear
                .map(async (item) => {


                    const response = await api.post("panel/generate/manual/flex", {
                        product_id: item.id
                    }, {
                        responseType: 'blob', // Indique que você espera um Blob como resposta
                    });

                    if (response.status === 401) {
                    } else if (response.status === 200) {
                        // Cria um Blob a partir da resposta
                        const blob = new Blob([response.data], { type: 'application/pdf' });

                        // Converte o Blob para um ArrayBuffer
                        const arrayBuffer = await blob.arrayBuffer();

                        // Carrega o PDF e adiciona suas páginas ao PDF combinado
                        const pdfDoc = await PDFDocument.load(arrayBuffer);
                        const copiedPages = await combinedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
                        copiedPages.forEach((page) => combinedPdf.addPage(page));
                    }

                })
            );


            // Serializa o PDF combinado
            const pdfBytes = await combinedPdf.save();

            // Cria um Blob a partir do PDF combinado
            const blob = new Blob([pdfBytes], { type: 'application/pdf' });

            const url = URL.createObjectURL(blob);

            // Ação com o URL (abrir em nova aba ou iniciar download)
            const link = document.createElement('a');
            link.href = url;
            link.download = `flex.pdf`; // Nome do arquivo combinado
            document.body.appendChild(link); // Adiciona o link ao DOM
            link.click(); // Simula um clique para iniciar o download
            document.body.removeChild(link); // Remove o link do DOM

            toast.update(loadingToastId, {
                render: "Sucesso!",
                type: "success",
                isLoading: false,
                autoClose: 1000
            });
        } catch (error) {
            console.error('Erro ao gerar PDF:', error);
            toast.update(loadingToastId, {
                render: "Erro ao processar o pedido.",
                type: "error",
                isLoading: false,
                autoClose: 1000
            });
        }
    };
    const handleGenerateReportAllJadlog = async () => {
        const loadingToastId = toast.loading("Processando o pedido...");

        try {
            // Cria um novo PDF onde todos os PDFs serão combinados
            const combinedPdf = await PDFDocument.create();

            const filterArray = selectItems.filter(item => item.type_delivery == "2")

            if (filterArray.length == 0) {

                return toast.update(loadingToastId, {
                    render: "Nenhuma etiqueta jadlog foi encontrada!",
                    type: "error",
                    isLoading: false,
                    autoClose: 1000
                });
            }

            await Promise.all(selectItems
                ?.filter(item => item.type_delivery === "2")  // Filtra antes de mapear
                .map(async (item) => {


                    const response = await api.post("panel/generate/manual", {
                        product_id: item.id
                    }, {
                        responseType: 'blob', // Indique que você espera um Blob como resposta
                    });

                    if (response.status === 401) {
                    } else if (response.status === 200) {
                        // Cria um Blob a partir da resposta
                        const blob = new Blob([response.data], { type: 'application/pdf' });

                        // Converte o Blob para um ArrayBuffer
                        const arrayBuffer = await blob.arrayBuffer();

                        // Carrega o PDF e adiciona suas páginas ao PDF combinado
                        const pdfDoc = await PDFDocument.load(arrayBuffer);
                        const copiedPages = await combinedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
                        copiedPages.forEach((page) => combinedPdf.addPage(page));
                    }

                })
            );


            // Serializa o PDF combinado
            const pdfBytes = await combinedPdf.save();

            // Cria um Blob a partir do PDF combinado
            const blob = new Blob([pdfBytes], { type: 'application/pdf' });

            const url = URL.createObjectURL(blob);

            // Ação com o URL (abrir em nova aba ou iniciar download)
            const link = document.createElement('a');
            link.href = url;
            link.download = `jadlog.pdf`; // Nome do arquivo combinado
            document.body.appendChild(link); // Adiciona o link ao DOM
            link.click(); // Simula um clique para iniciar o download
            document.body.removeChild(link); // Remove o link do DOM

            toast.update(loadingToastId, {
                render: "Sucesso!",
                type: "success",
                isLoading: false,
                autoClose: 1000
            });
        } catch (error) {
            console.error('Erro ao gerar PDF:', error);
            toast.update(loadingToastId, {
                render: "Erro ao processar o pedido.",
                type: "error",
                isLoading: false,
                autoClose: 1000
            });
        }
    };
    const handleGenerateReportAllDeclaration = async () => {
        const loadingToastId = toast.loading("Processando o pedido...");

        try {
            // Cria um novo PDF onde todos os PDFs serão combinados
            const combinedPdf = await PDFDocument.create();

            await Promise.all(selectItems
                ?.filter(item => item.type_delivery === "1" || item.type_delivery == "2")  // Filtra antes de mapear
                .map(async (item) => {


                    const response = await api.post("panel/generate/declaration", {
                        product_id: item.id
                    }, {
                        responseType: 'blob', // Indique que você espera um Blob como resposta
                    });

                    if (response.status === 401) {
                    } else if (response.status === 200) {
                        // Cria um Blob a partir da resposta
                        const blob = new Blob([response.data], { type: 'application/pdf' });

                        // Converte o Blob para um ArrayBuffer
                        const arrayBuffer = await blob.arrayBuffer();

                        // Carrega o PDF e adiciona suas páginas ao PDF combinado
                        const pdfDoc = await PDFDocument.load(arrayBuffer);
                        const copiedPages = await combinedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
                        copiedPages.forEach((page) => combinedPdf.addPage(page));
                    }

                })
            );



            // Serializa o PDF combinado
            const pdfBytes = await combinedPdf.save();

            // Cria um Blob a partir do PDF combinado
            const blob = new Blob([pdfBytes], { type: 'application/pdf' });

            const url = URL.createObjectURL(blob);

            // Ação com o URL (abrir em nova aba ou iniciar download)
            const link = document.createElement('a');
            link.href = url;
            link.download = `declaração.pdf`; // Nome do arquivo combinado
            document.body.appendChild(link); // Adiciona o link ao DOM
            link.click(); // Simula um clique para iniciar o download
            document.body.removeChild(link); // Remove o link do DOM

            toast.update(loadingToastId, {
                render: "Sucesso!",
                type: "success",
                isLoading: false,
                autoClose: 1000
            });
        } catch (error) {
            console.error('Erro ao gerar PDF:', error);
            toast.update(loadingToastId, {
                render: "Erro ao processar o pedido.",
                type: "error",
                isLoading: false,
                autoClose: 1000
            });
        }
    };
    const handleUpdateAllRequests = async (status) => {

        const loadingToastId = toast.loading("Processando o pedido...");

        await Promise.all(selectItems?.map(async item => {
            const response = await api.put("requests/update", {
                status: status,
                id: item.id
            })
        }))
        getAll()
        toast.update(loadingToastId, {
            render: "Sucesso!",
            type: "success",
            isLoading: false,
            autoClose: 1000
        });
    }
    const storageExcel = async () => {
        try {
            // Extraindo os IDs de selectItems
            const ids = selectItems.map(item => item.id);
            // Verificando se há IDs antes de enviar a requisição
            if (ids.length === 0) {
                console.warn("Nenhum item selecionado para exportação.");
                return;
            }

            // Fazendo a requisição para gerar o arquivo
            const response = await api.post("/panel/generate/salles", { ids }, {
                responseType: 'blob' // Importante para baixar arquivos binários
            });

            // Criando um URL para o blob recebido
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Criando um link temporário para o download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'relatorio.xlsx'); // Nome do arquivo
            document.body.appendChild(link);
            link.click();

            // Limpando o objeto URL para liberar memória
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);

        } catch (error) {
            console.error("Erro ao baixar o Excel:", error);
        }
    };

    useEffect(() => {
        getDashboard()
    }, [])

    return (
        <RequestsContext.Provider value={{
            getAll,
            haveRequests,
            get,
            getByDate,
            getById,
            getLast30Days,
            getByUniqDate,
            setUniqDayFilter,
            uniqDayFilter,
            getRangeDate,
            setStartDateFilter,
            setEndDateFilter,
            requestInfo,
            setModalRequestInfo,
            modalRequestInfo,
            setFocus,
            removeFocus,
            requests,
            getDashboard,
            dashboard,
            inputSearchFocus,
            handleSelectItems,
            setSelectItems,
            selectItems,
            setModalPrintItems,
            modalPrintItems,
            handleGenerateReportAllFlex,
            handleGenerateReportAllJadlog,
            handleGenerateReportAllDeclaration,
            handleUpdateAllRequests,
            userData,
            getBySku,
            storageExcel,
            setTypeFilter,
            typeFilter,
            getAllRequests

        }}>
            {children}
        </RequestsContext.Provider>
    );
}

export default RequestsProvider;
